import React, { useEffect } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";

const OurStory = () => {
  return (
    <section className="consult-specialist-section ourStory_section">
      <Container fluid className="showcase-container">
        <div>
          {/* <Row className="d-flex align-items-center"> */}
            {/* <Col md={{ span: 6, offset: 6 }}> */}
              <div className="inner-wrap text-center text-lg-left text-sm-center text-md-center">
                {/* <span>Feel Free To Talk With Us</span> */}
                <h2 className="text-capitalize">Our Story</h2>
                <p>
                  Dynasty Jewelers are manufacturers and retailers
                  of custom and unique fine {Je_welryspelling}.
                </p>
                <p>Our family owned and operated for over 40 years.
                  We are not your traditional {Je_welryspelling}.</p>
                <p>While we offer a vast inventory in our stores to choose
                  from, we are specialists in creating custom and unique
                  pieces for our clients. We aren't your typical "mall"
                  store and we will prove it to you!</p>
                  <div className="text-lg-left text-sm-center text-md-center">

                <Link
                  className="btn outline-base-btn large"
                  to="/our-story"
                >
                Read More
                </Link>
                  </div>
              </div>
            {/* </Col> */}
            {/* <Col md={6} className="p-0">
              <Image src={`${ImageUrl}theme/showcase/consult-img.webp`} alt="Feel Free To Talk With Us" />
            </Col> */}
          {/* </Row> */}
        </div>
      </Container>
    </section>
  );
};

export default OurStory;
